import { render, staticRenderFns } from "./CustomersProductInsights.vue?vue&type=template&id=4e843783"
import script from "./CustomersProductInsights.vue?vue&type=script&lang=js"
export * from "./CustomersProductInsights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports